import { localiseWeekday } from '~~/common/js/universal/datetime';

const CATEGORIES_SEPARATOR = ' · ';
export const MAX_CATEGORIES = 4;
export const CLOSED = 'closed';

export const getPoiCategoryString = (poiType, categories) => {
  const parts = poiType ? [poiType] : [];

  return parts
    .concat(categories)
    .slice(0, MAX_CATEGORIES)
    .join(CATEGORIES_SEPARATOR);
};

export const getToday = () => {
  const withSundayStart = new Date().getDay();
  return withSundayStart === 0 ? 6 : withSundayStart - 1;
};

export const currentOpeningHours = (openingHours, locale) => {
  if (!openingHours) {
    return null;
  }

  const today = getToday();

  const todayKey = Object.keys(openingHours)[today];
  const todayTimes = openingHours[todayKey];
  if (!todayTimes) {
    return null;
  }
  if (todayTimes.periods.length === 0) {
    return CLOSED;
  }

  const periods = todayTimes.periods.map(({ start, end }) => `${start} - ${end}`);
  return `${periods.join(', ')} (${localiseWeekday(locale, today)})`;
};
